import ExpandedChip from '@/components/Chips/ExpandedChip';
import { useMemo } from 'react';
import { OnboardingClass } from '../../steps';
import { StepOption } from './Step';
import { ActionButton, ChipContainer, Content, PurposeNextSection, Question, Section, Subtitle, Title } from './Styled';

const MAX_ANSWERS_NUMBER = 20;
const seed = Array.from({ length: MAX_ANSWERS_NUMBER }, () => Math.random() - 0.5);
interface Props {
    title: string;
    setPurpose: (purpose: OnboardingClass | string) => void;
    selectedPurpose: OnboardingClass | string;
    options: StepOption[];
    show: boolean;
    onNext: VoidFunction;
    isExistingUser?: boolean;
    randomize?: boolean;
}

export default function NewPurpose({ title, selectedPurpose, setPurpose, options, show, onNext, isExistingUser, randomize }: Props) {
    const randomizedOptions = useMemo(() => {
        if (!randomize) {
            return options;
        }

        const randomized = options.map((option, index) => ({ ...option, index })).sort((a, b) => seed[a.index] - seed[b.index]);

        return randomized;
    }, [options, randomize]);

    const renderTitle = () => {
        return isExistingUser ? (
            <>
                <Title>Welcome Back!</Title>
                <Subtitle>We'd love to hear if anything has changed so we can personalize your experience</Subtitle>
            </>
        ) : (
            <>
                <Title>Welcome to D-ID!</Title>
                <Subtitle>Tell us a bit more about yourself so we can personalize your experience.</Subtitle>
            </>
        );
    };

    return (
        <Content show={show}>
            <Section>{renderTitle()}</Section>
            <Section>
                <Question>{title}</Question>
                <ChipContainer>
                    {randomizedOptions.map((option, idx) => (
                        <ExpandedChip
                            key={idx}
                            value={{ label: option.label, explanation: '' }}
                            onClick={() => setPurpose(option.id ?? option.label)}
                            checked={selectedPurpose === option.id || selectedPurpose === option.label}
                            isMultiple={false}
                            icon={option.icon}
                        />
                    ))}
                </ChipContainer>
                <PurposeNextSection>
                    <ActionButton fullWidth variant="contained" color="secondary" onClick={onNext} disabled={!selectedPurpose}>
                        Next
                    </ActionButton>
                </PurposeNextSection>
            </Section>
        </Content>
    );
}
